export default __webpack_public_path__ + "static/media/kashier_wallet.6242d0f2.svg";